import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosArrowDropdown } from 'react-icons/io';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';
import { LANGUAGES } from '../utils';

const ProgramContentBenefits = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const { program: { benefits = [], benefitsUs = [] } = {} } = useEvieAppContext();

  const programBenefits = language.slice(0, 2) === LANGUAGES.EN ? benefitsUs : benefits;

  return (
    <section className="program-content">
      <ul className="program-content__benefits">
        {programBenefits.map((benefit) => (
          <li key={benefit} className="program-content__benefits_benefit">
            <IoIosArrowDropdown /> <p>{benefit}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProgramContentBenefits;
